// extracted by mini-css-extract-plugin
export var modal = "_f8-0";